import { render, staticRenderFns } from "./TextPanel.vue?vue&type=template&id=953adade&scoped=true"
import script from "./TextPanel.vue?vue&type=script&lang=js"
export * from "./TextPanel.vue?vue&type=script&lang=js"
import style0 from "./TextPanel.vue?vue&type=style&index=0&id=953adade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953adade",
  null
  
)

export default component.exports